export default function (service) {
    if (!service) return 2
    if (service === "cricket-free") return 1
    else return 2
}
